<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
          { label: ('SUCURSAL' | regionWord), link: '/branch/branch-list' },
          { label: 'DETALLE' }
        ]">
      </app-breadcrumb>
    </div>

    <div class="row clearfix">
      <!-- ==== PANEL IZQUIERDO (se mantiene como lo tenias) ==== -->
      <div class="col-lg-4 col-md-12">
        <div class="card card-personal-profile">
          <div class="profile-content">
            <img
              [src]="branchImage"
              alt="{{ gemp.nombre || 'LOGO' }}"
              class="profile-img"
            />
            <div class="profile-text">
              <div class="profile-name">
                {{ branch.nombre || '—' }}
              </div>
              <div class="profile-subtext">
                ESTADO: {{ branch.status || '—' }}
              </div>
            </div>
          </div>

          <div class="profile-meta">
            <div class="meta-item" *ngIf="showBusinessGroup">
              <div class="meta-label">GRUPO EMPRESARIAL</div>
              <div class="meta-value">{{ gemp.nombre || '—' }}</div>
            </div>

            <div class="meta-item">
              <div class="meta-label">REGISTRO SANITARIO</div>
              <div class="meta-value">{{ branch.registroSanitario || '—' }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- ==== PANEL DERECHO (nuevo estilo tipo hospital, sin accordion) ==== -->
      <div class="col-lg-8 col-md-12">
        <!-- IDENTIDAD Y CONTACTO -->
        <div class="info-card">
          <div class="info-card__header">
            <div class="info-card__title">
              <mat-icon>assignment_ind</mat-icon>
              IDENTIDAD Y CONTACTO
            </div>
          </div>

          <div class="info-card__body grid-2">
            <div class="field">
              <div class="field__label">NOMBRE COMPLETO</div>
              <div class="field__value">{{ branch.responsable || '—' }}</div>
            </div>

            <div class="field">
              <div class="field__label">TELEFONO</div>
              <div class="field__value">
                {{ (branch.telefonoResponsable || '') | formatMobile }}
              </div>
            </div>

            <div class="field no-uppercase">
              <div class="field__label">CORREO</div>
              <div class="field__value">{{ branch.emailResponsable || '—' }}</div>
            </div>
          </div>
        </div>

        <!-- DOMICILIO Y UBICACION -->
        <div class="info-card">
          <div class="info-card__header">
            <div class="info-card__title">
              <mat-icon>home</mat-icon>
              DOMICILIO Y UBICACION
            </div>
          </div>

          <div class="info-card__body grid-2">
            <div class="field">
              <div class="field__label">DOMICILIO</div>
              <div class="field__value">{{ branch.domicilio || '—' }}</div>
            </div>

            <div class="field">
              <div class="field__label">ASENTAMIENTO</div>
              <div class="field__value">{{ branch.nombreAsentamiento || '—' }}</div>
            </div>

            <div class="field">
              <div class="field__label">CODIGO POSTAL</div>
              <div class="field__value">{{ branch.codigoPostal || '—' }}</div>
            </div>

            <div class="field">
              <div class="field__label">TIPO DE ASENTAMIENTO</div>
              <div class="field__value">{{ branch.tipoAsentamiento || '—' }}</div>
            </div>

            <div class="field">
              <div class="field__label">MUNICIPIO</div>
              <div class="field__value">{{ branch.municipio || '—' }}</div>
            </div>

            <div class="field">
              <div class="field__label">ESTADO</div>
              <div class="field__value">{{ branch.estado || '—' }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- /PANEL DERECHO -->
    </div>
  </div>
</section>
